import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const Dropdown = (props) => {
    return (
        <>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
                <label htmlFor={props.id}> {props.title}</label>
                <Select
                    className={ props.isValid ? 'border-error' : ''}
                    value={props.value}
                    onChange={props.onChange}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                    required={props.required}
                    id={props.id}
                    readOnly={props.readOnly}
                    name={props.name}>
                    <MenuItem value="">{props.placeholder} </MenuItem>
                    {props.options.map((option, $index) => {
                        return (<MenuItem value={option.value} key={$index.toString()}>{option.label}</MenuItem>)
                    })}
                </Select>
            </FormControl>
        </>
    )
}



export default Dropdown;